import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class NavigatePartnersTool implements IManagementTool {
  private _router = inject(Router);

  readonly name = 'navigate-partners';
  readonly label = 'Partners';
  readonly icon = 'handshake';
  readonly description = 'Navigate to the partners management page';

  async run(_context: IToolRunContext): Promise<void> {
    await this._router.navigate(['/management/partners']);
  }
}
